import HierarchicalReportLayout, { formatters } from 'components/hierarchical-report/Layout';

import pingCheckStore from '../../stores/pingCheck';

import { PingCheckReportProvider, usePingCheckReportStore } from './store'

export default class PingCheckReport extends HierarchicalReportLayout {
  store = pingCheckStore;
  title = 'Ping Check';

  useNewStore = () => {
    const store = usePingCheckReportStore()
    const { report: { useLoad } } = store
    useLoad()
    return store
  }

  configure = {
    filterby: {
      options: [
        {
          value: 'publisher',
          get label() {
            return <formatters.Loadable isLoading={pingCheckStore.publisher.isLoading}>Publisher</formatters.Loadable>
          },
          options: pingCheckStore.publisher.fetchData,
        },
        {
          value: 'allocation',
          get label() {
            return <formatters.Loadable isLoading={pingCheckStore.allocation.isLoading}>Allocation</formatters.Loadable>
          },
          options: pingCheckStore.allocation.fetchData,
        },
      ],
    },
    groupby: {
      default: ['publisher', 'allocation'],
      options: [
        { value: 'publisher', label: 'publisher', group: 'Traffic' },
        { value: 'allocation', label: 'allocation', group: 'Traffic' },

        { value: 'hour', label: 'Hour', group: 'Full Time' },
        { value: 'day', label: 'Day', group: 'Full Time' },
        { value: 'month', label: 'Month', group: 'Full Time' },
        { value: 'year', label: 'Year', group: 'Full Time' },

        { value: 'hour_unittime', label: 'Hour', group: 'Unit Time' },
        { value: 'day_unittime', label: 'Day', group: 'Unit Time' },
        { value: 'weekday_unittime', label: 'Weekday', group: 'Unit Time' },
        { value: 'month_unittime', label: 'Month', group: 'Unit Time' },
      ],
    },
    metrics: {
      default: ['pingSuccess', 'medianLatency', 'show', 'showPC'],
      options: [
        { value: 'pingSuccess', label: 'Request success', group: 'Default' },
        { value: 'pingSuccessPC', label: 'Request success %', group: 'Ratio' },
        { value: 'pingFail', label: 'Request fail', group: 'Default' },
        { value: 'pingFailPC', label: 'Request fail %', group: 'Ratio' },
        { value: 'show', label: 'Show', group: 'Default' },
        { value: 'showPC', label: 'show %', group: 'Ratio' },
        { value: 'medianLatency', label: 'AVG Latency', group: 'Default' },
      ],
    },
    sortby: {
      default: ['total desc'],
      options: [
        { value: 'total', label: 'Requests', group: 'Default' },
      ],
    },
  }

  metricColumns = [{
    dataField: 'pingSuccess',
    customSort: true,
    text: "Request Success",
    formatter: formatters.drilldown(this.newTab, 'pingSuccess'),
  }, {
    dataField: 'pingSuccessPC',
    customSort: true,
    text: "Request Success (%)",
    formatter: cell => formatters.percent(cell),
  }, {
    dataField: 'pingFail',
    customSort: true,
    text: "Request Fail",
    formatter: formatters.drilldown(this.newTab, 'pingFail'),
  }, {
    dataField: 'pingFailPC',
    customSort: true,
    text: "Request Fail (%)",
    formatter: cell => formatters.percent(cell),
  }, {
    dataField: 'show',
    customSort: true,
    text: "Show",
    formatter: formatters.drilldown(this.newTab, 'show'),
  }, {
    dataField: 'showPC',
    customSort: true,
    text: "Show (%)",
    formatter: cell => formatters.percent(cell),
  }, {
    dataField: 'medianLatency',
    customSort: true,
    text: "AVG Latency",
    formatter: cell => formatters.seconds(cell),
  },
  ]

  get columns() {
    const { metrics, groupby } = this.state || {}
    const metricColumns = this.metricColumns.filter(d => metrics && metrics.includes(d.dataField))

    return [{
      dataField: 'value',
      text: groupby && groupby.join(' / '),
      customSort: true,
      sortValue: row => row.name || row.keyString || row.value,
      formatter: formatters.name,
    }, {
      dataField: 'total',
      customSort: true,
      text: "Total Requests",
      sortValue: row => row.name || row.value,
      formatter: (cell, row) => cell === 0 ? '--' : formatters.drilldown(this.newTab, 'total')(cell, row),
    },
    ...metricColumns,
    ]
  }

  ReportProvider = ({ children }) => <PingCheckReportProvider>
    {children}
  </PingCheckReportProvider>
}
